import PropTypes from "prop-types";
import { Link } from "react-router-dom";
export default function VenueCard({ venue, dataPoints }) {

  const extractPostcode = (address) => {
    if (!address) return 'No address available';
    
    const postcodeRegex = /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/i;
    const match = address.match(postcodeRegex);
    
    return match ? match[0] : 'No postcode found';
  };

  const postcode = extractPostcode(venue?.VenueAddress);

  return (
    <Link to={"/venues/" + venue?.OrgID} state={{ venue }}>
      <div className="flex flex-col gap-3">
        <div className="relative w-full h-[197px]">
          <img
            src={venue?.DirectoryDisplayImage}
            className="w-full h-full object-cover rounded-[4px] border-[1px] border-solid border-[#E3E3E3]"
          />
          {venue?.MembershipsAvailable === 1 && (
            <span className="select-none uppercase pl-[11.8px] pr-[9.5px] bg-white rounded-[4px] text-[12px] leading-[24px] tracking-[2.4px] font-semibold top-2 right-2 absolute">
              Memberships Available
            </span>
          )}
        </div>
        <div className="flex flex-col gap-1">
          <h3>{venue?.DirectoryDisplayName}</h3>
          {postcode && <p className="text-[#727272]">{postcode}</p>}
        </div>
        <div className="grid grid-cols-2 gap-2">
          {venue?.DataPoints?.map((temp) => {
            return (
              <div className="flex gap-[10px]" key={temp.DataPointGUID}>
                <img className="w-[24px] h-[24px]" src={temp.DataPointIcon} alt={temp.DataPointType} />
                <h4 className="text-[#727272]">{temp.DataPointType.split(" ")[0]} / {temp?.DataPointPrefix + temp?.DataPointValue + temp?.DataPointSuffix}</h4>
              </div>
            )
          })}
        </div>
      </div>
    </Link>
  );
}

VenueCard.propTypes = {
  venue: PropTypes.shape({
    membershipAvailable: PropTypes.bool,
    websiteLink: PropTypes.string,
    bookingLink: PropTypes.string,
    aboutIntro: PropTypes.string,
    aboutSub: PropTypes.string,
    BookingAvailable: PropTypes.number,
    DataPoints: PropTypes.array,
    DirectoryDisplayImage: PropTypes.string,
    DirectoryDisplayName: PropTypes.string,
    IsActive: PropTypes.number,
    MembershipsAvailable: PropTypes.number,
    OrgID: PropTypes.number,
    OrgPartnerFriendlyName: PropTypes.string,
    OrgSiteLogo: PropTypes.string,
    OrgWebsiteURL: PropTypes.string,
    VenueAddress: PropTypes.string,
    VenueHTMLBlurb: PropTypes.string,
    latestAirTemp: PropTypes.string,
    latestWaterTemp: PropTypes.string,
  }),
  dataPoints: PropTypes.array,
};
